<template>
  <div v-if="customers && customers.length && customers.length > 1"
       class="kt-header__topbar-item kt-header__topbar-item--search dropdown">
    <div class="kt-header__topbar-wrapper">
      <span class="customer-selection-dropdown-holder">
        <multiselect
          v-model="selected_customer"
          label="name"
          track-by="uuid"
          :allow-empty="false"
          :options="customers"
          :show-labels="false"
          @select="changeCustomer" />
      </span>
    </div>
  </div>
</template>

<script>
/* webpack-strip-block:removed */

import { isPodcaster } from 'Helpers/misc';

export default {
  data() {
    return {
      customers: window.customer_select_options,
      selected_customer: {},
    };
  },
  beforeMount() {
    this.selected_customer = _.find(this.customers, 'active');
  },
  methods: {
    /**
     * `POST`s a select customer request to the backend, then redirects the user. The correct feed noun is replaced into the URL,
     * i.e '/feeds' would become '/podcasts' when switching from broadcaster to podcaster.
     *
     * A user can't switch from the items index on broadcaster into the (hidden) items index on podcaster, and is instead sent to home `/`.
     *
     * @param { Customer } customer
     */
    async changeCustomer(customer) {
      try {
        await axios.post('/api/v1/select-customer', {
          customer_uuid: customer.uuid,
        });

        toastr.success(`Redirecting to ${customer.name}...`);

        /**
         * just the path root (i.e '/items'), but the correct noun for podcasts/feeds will be chosen, and podcasters are
         * redirected to home if they used the switcher to come into the items index page
         */
        const path_root = (() => {
          const parts = window.location.pathname.split('/').filter(part => part.length);

          if (parts.length === 0) return '';

          const unmodified_root = parts[0]; // i.e: 'feeds', 'artwork', 'storage'

          if (isPodcaster()) {
            // podcasters should go to home if trying to switch into the items index page, but not when switching into item edit etc.
            // if the parts count is 1 and contains the string 'item' or 'episode', it was the index page
            const is_items_index = parts.length === 1 && unmodified_root.search(/(episode|item)/i) !== -1;
            if (is_items_index) return '';

            // otherwise, replace any 'feed' with 'podcast'
            return unmodified_root.replace(/feed/gi, 'podcast');
          }

          // otherwise, replace any 'podcast' with 'feed'
          return unmodified_root.replace(/podcast/gi, 'feed');
        })();

        // here we wait to define variables until after all the promises are resolved
        const [identical_url, base_url] = await Promise.all([
          fetch(window.location.href),
          fetch(`${window.location.origin}/${path_root}`),
        ]);

        if (identical_url.ok) window.location.reload();
        else if (base_url.ok) window.location.href = base_url.href;
        else window.location.href = '/';
      } catch (error) {
        window.handleAxiosError(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  span.customer-selection-dropdown-holder {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    height: 44px;
    cursor: pointer;
  }
</style>
